import React from "react";
import {
  DDD_DD_MMM_YYYY_HH_MM_SS_A,
  EXPECTED_DELIVERY_DATE_CAP,
  MM_DD_YY,
  TIME_ZONE,
} from "../../../utils/const";
import "moment-timezone";
import Moment from "react-moment";
import UniversalViewModal from "../../Modal/UniversalViewModal";
import NumberFormat from "react-number-format";
import { getStatusClass } from "../../../utils/utils";
export function TransactionViewModal({
  handleConfirmHide,
  isConfirmModal,
  data,
}) {
  const {
    id,
    address_1,
    address_2,
    city,
    amount,
    commission,
    state_province,
    country_region,
    zip_code,
    createdAt,
    confirmation_id = "-",
    confirmation_date = "-",
    ip_country = "-",
    sc_transactionId = "-",
    sc_type = "-",
    receiver,
    sender,
    deposite_type,
    transaction_status,
    transactionStatusId,
    expecteddeliverydate,
  } = data;

  const { name = " - " } = deposite_type || {};

  const dataArray = [];

  const renderUserAddress = (data) => {
    let address = "";
    if (!data) {
      return;
    }

    if (address_1) {
      address = address.concat(`${address_1},`);
    }
    if (address_2) {
      address = address.concat(` ${address_2},`);
    }
    if (city) {
      address = address.concat(` ${city.name},`);
    }
    if (state_province) {
      address = address.concat(` ${state_province},`);
    }
    if (country_region) {
      address = address.concat(` ${country_region},`);
    }
    if (zip_code) {
      address = address.concat(` ${zip_code}`);
    }

    return address ? address : "-";
  };
  const renderReceiverName = (receiver) => {
    let name = "";
    if (!receiver) {
      return;
    }

    if (receiver.firstname) {
      name = name.concat(`${receiver.firstname}`);
    }
    if (receiver.lastname) {
      name = name.concat(` ${receiver.lastname}`);
    }
    if (receiver.account_number) {
      name = name.concat(` - ${sender.account_number}`);
    }

    return name;
  };
  const renderSenderName = (sender) => {
    let name = "";
    if (!sender) {
      return;
    }
    if (sender.firstname) {
      name = name.concat(`${sender.firstname}`);
    }
    if (sender.lastname) {
      name = name.concat(` ${sender.lastname}`);
    }
    if (sender.account_number) {
      name = name.concat(` - ${sender.account_number}`);
    }

    return name;
  };

  const renderStatusType = (status) => {
    const { name } = status || {};
    return (
      <span className={`${getStatusClass(name)} status-color text-capitalize`}>
        {status.name}
      </span>
    );
  };
  const renderConfirmationDate = (confirmation_date) => {
    if (!confirmation_date) return "-";
    return (
      <Moment
        date={confirmation_date}
        format={DDD_DD_MMM_YYYY_HH_MM_SS_A}
        tz={TIME_ZONE}
      />
    );
  };

  const renderdate = (createdAt) => {
    if (!createdAt) return "-";
    return <Moment date={createdAt} format={DDD_DD_MMM_YYYY_HH_MM_SS_A} tz={TIME_ZONE} />;
  };

  const renderExpectedDeliveryDate = () => {
    return (
      <>
        {transactionStatusId !== 1 ? (
          "-"
        ) : (
          <span>
            {`Pending Until `}
            <Moment date={expecteddeliverydate} format={MM_DD_YY} tz={TIME_ZONE} />
          </span>
        )}
      </>
    );
  };

  const renderDepositType = (depositeType) => {
    let depositeTypeClass = "";
    depositeTypeClass =
      name && name === "Debit card"
        ? "depositeType-debitCard"
        : name && name === "Credit Card"
        ? "depositeType-credit"
        : name && name === "Wire Transfer"
        ? "depositeType-wire-transfer"
        : name && name === "ACH"
        ? "depositeType-ach"
        : name && name === "eCheck"
        ? "depositeType-eCheck"
        : name && name === "General"
        ? "depositeType-general"
        : "depositeType-general";
    return (
      <>
        <div className="row ml-1">
          <li className={`${depositeTypeClass}`}></li>
          {name}
        </div>
      </>
    );
  };

  const amountFormatter = (amount) => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  dataArray.push({ key: "Transaction ID", value: id });
  dataArray.push({ key: "Address", value: renderUserAddress(data) });
  dataArray.push({ key: "Amounts", value: amountFormatter(amount) });
  dataArray.push({ key: "Commission", value: amountFormatter(commission) });
  dataArray.push({ key: "Deposit Type", value: renderDepositType(name) });
  dataArray.push({
    key: "Status",
    value: renderStatusType(transaction_status),
  });
  dataArray.push({ key: "Date", value: renderdate(createdAt) });
  // dataArray.push({
  //   key: EXPECTED_DELIVERY_DATE_CAP,
  //   value: renderExpectedDeliveryDate(),
  // });
  dataArray.push({
    key: "Confirmation ID",
    value: confirmation_id ? confirmation_id : "-",
  });
  dataArray.push({
    key: "Confirmation Date",
    value: renderConfirmationDate(confirmation_date),
  });
  dataArray.push({ key: "IP", value: ip_country ? ip_country : "-" });
  dataArray.push({
    key: "SC Transaction ID",
    value: sc_transactionId ? sc_transactionId : "-",
  });
  dataArray.push({ key: "SC Type", value: sc_type ? sc_type : "-" });
  dataArray.push({ key: "Receiver", value: renderReceiverName(receiver) });
  dataArray.push({ key: "Sender", value: renderSenderName(sender) });

  return (
    <UniversalViewModal
      handleConfirmHide={handleConfirmHide}
      isConfirmModal={isConfirmModal}
      title={`Transaction Details - ${id}`}
      dataArray={dataArray}
    />
  );
}
